var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLittleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99948 16C3.58853 16 0 12.4111 0 8C0 3.58872 3.58853 0 7.99945 0C12.411 0 16 3.58872 16 8C16 12.4111 12.411 16 7.99948 16ZM7.99948 1.73456C4.54487 1.73456 1.73456 4.54523 1.73456 8C1.73456 11.4548 4.54496 14.2654 7.99956 14.2654C11.4545 14.2654 14.2655 11.4548 14.2655 8C14.2655 4.54523 11.4544 1.73456 7.99948 1.73456Z",
    fill: "#B1C2CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79796 4.91361C6.5623 5.09942 6.44449 5.34519 6.44449 5.65119C6.44449 5.9575 6.58841 6.2007 6.8766 6.38126C7.16459 6.56194 7.82967 6.77526 8.87212 7.02111C9.91435 7.26713 10.7235 7.6359 11.2998 8.12737C11.8758 8.6193 12.1641 9.33685 12.1641 10.28C12.1641 11.2234 11.7949 11.9885 11.0562 12.5756C10.3177 13.1627 9.26788 13.4666 8.06367 13.4979C5.95687 13.5526 4.51247 12.519 3.66406 11.4589L5.12539 9.743C6.30902 10.7364 7.183 11.3789 8.18871 11.3789C8.63883 11.3789 8.99249 11.2862 9.24918 11.1003C9.50574 10.9148 9.63423 10.6638 9.63423 10.3478C9.63423 10.0317 9.49798 9.78098 9.2257 9.59514C8.95313 9.40958 8.41383 9.22145 7.60729 9.03053C6.32909 8.73977 5.39414 8.3607 4.80251 7.89408C4.21049 7.42752 3.91471 6.69499 3.91471 5.69641C3.91471 4.69792 4.28913 3.92759 5.03823 3.38572C5.78702 2.84375 6.72197 2.5 7.84298 2.5C8.57624 2.5 9.35407 2.63367 10.0396 2.90455C10.7569 3.18803 11.3115 3.57619 11.8862 4.10341L10.6448 5.81945C9.69154 5.12713 8.7804 4.63506 7.7644 4.63506C7.35572 4.63503 7.0337 4.72797 6.79796 4.91361Z",
    fill: "#B1C2CF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLittleLogo);
export default __webpack_public_path__ + "static/media/littleLogo.af1b114fa30ee3e7872aabe91682350d.svg";
export { ForwardRef as ReactComponent };